import { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";

import Spinner from "./spinner";

import "../styles/workingDialog.scss";

export interface IWorkingModalProps {
	params?: IWorkingModalParams;
}

/**
 * Parameters for the working modal.
 */
export interface IWorkingModalParams {
	/** The title of the modal. Defaults to blank. */
	title?: string;

	/** The content text of the modal. Defaults to "Working...". */
	content?: React.ReactNode | string;
}

const WorkingModal: React.FunctionComponent<IWorkingModalProps> = ({ params }) => {
	// Buffer these values so when params changes to undefined to hide the dialog we don't see a flash of the default values
	const [titleText, setTitleText] = useState<string | undefined>(undefined);
	const [content, setContent] = useState<string | React.ReactNode | undefined>(undefined);

	useEffect(() => {
		if (params) {
			setTitleText(params.title);
			setContent(params.content);
		}		
	}, [params])

	return (
		<Dialog
			open={!!params}
			fullScreen={false}
			maxWidth='xs'
			fullWidth={true}>
			<DialogTitle
				id="title">
				{titleText}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					<Spinner dependency={true} text={content || "Working..."}></Spinner>					
				</DialogContentText>
			</DialogContent>
			<DialogActions>
			</DialogActions>
		</Dialog>
	);
};

export default WorkingModal;